import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Clicca per modificare la password")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Annulla")
const _hoisted_3 = {
  key: 0,
  class: "form-group"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Login abilitata (visibile solo ad admin)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_input = _resolveComponent("form-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_form_input, {
      type: "text",
      label: "Email di login",
      modelValue: _ctx.value.username,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value.username) = $event)),
      placeholder: "Username",
      disabled: !_ctx.$store.state.isAdmin()
    }, null, 8, ["modelValue", "disabled"]),
    _createElementVNode("label", {
      class: "text-warning pointer",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showPasswordChange && _ctx.showPasswordChange(...args)))
    }, [
      (!_ctx.showPassword)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_1
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_2
          ], 64))
    ]),
    _createVNode(_component_form_input, {
      type: "password",
      label: "Password",
      modelValue: _ctx.value.password,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.value.password) = $event)),
      disabled: !_ctx.showPassword,
      placeholder: "Password"
    }, null, 8, ["modelValue", "disabled"]),
    (_ctx.$store.state.isAdmin())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.value.loginEnabled) = $event)),
            class: "form-control"
          }, null, 512), [
            [_vModelCheckbox, _ctx.value.loginEnabled]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}